import React, { useEffect, useState, useRef, useCallback } from "react";
import Globe from "react-globe.gl";

const locations = [
  { lat: 40.7128, lng: -74.0060, name: 'Leafwell Farm', clickable: true },
  { lat: 41.6535, lng: -74.7013, name: 'Monticello Raceway', clickable: true },
  { lat: 41.0976, lng: -73.9465, name: 'Palisades Mall', clickable: true },
  { lat: 40.8084, lng: -74.0672, name: 'American Dream Mall', clickable: true },
  { lat: 40.7128, lng: -74.0060, name: 'Manhattan', clickable: true },
  { lat: 41.5049, lng: -74.1040, name: 'Stewart International Airport', clickable: true },
  { lat: 42.0409, lng: -74.1182, name: 'Woodstock', clickable: true },
  { lat: 41.6743, lng: -74.6849, name: 'Bethel', clickable: true },
  { lat: 41.7762, lng: -74.8463, name: 'White Lake', clickable: true },
  { lat: 41.4046, lng: -74.3215, name: 'Goshen', clickable: true },
  { lat: 40.7306, lng: -73.9867, name: 'Local Farms', clickable: true },  // Generic location for demonstration
  { lat: 41.2033, lng: -77.1945, name: 'Closest Walmart', clickable: true }, // Generic location for demonstration
];

const getRandomLocation = () => {
  return locations[Math.floor(Math.random() * locations.length)];
};

const TheGlobe = () => {
  const globeEl = useRef();
  const [selectedLocation, setSelectedLocation] = useState(getRandomLocation());
  const [width, setWidth] = useState(window.innerWidth > 768 ? window.innerWidth * 0.6 : window.innerWidth / 1.175);
  const [height, setHeight] = useState(window.innerWidth > 768 ? 500 : 300);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedLocation(getRandomLocation());
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const MAP_CENTER = { lat: 0, lng: 0, altitude: 0.2 };
    if (globeEl.current) {
      globeEl.current.pointOfView(MAP_CENTER, 0);
    }
  }, []);

  useEffect(() => {
    if (globeEl.current) {
      const location = {
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        altitude: 1.5
      };

      globeEl.current.pointOfView(location, 1000);
    }
  }, [selectedLocation]);

  const handleMarkerClick = useCallback((location) => {
    if (location.clickable) {
      alert(`Zooming in on: ${location.name}`);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth > 768 ? window.innerWidth / 2 : window.innerWidth * 0.87);
      setHeight(window.innerWidth > 768 ? 500 : 300);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Globe
      ref={globeEl}
      globeImageUrl={"/images/earth-night.jpg"}
      backgroundColor="rgb(250,250,250)"
      labelsData={[selectedLocation]}
      labelText={"name"}
      labelSize={1.6}
      labelColor={() => "white"}
      labelDotRadius={0.4}
      labelAltitude={0.05}
      onLabelClick={handleMarkerClick}
      markers={locations}
      markerLat="lat"
      markerLng="lng"
      markerTooltip={(d) => d.name}
      width={width}
      height={height}
    />
  );
};

export default TheGlobe;
